import download from "slate-transcript-editor/util/downlaod";
import { MOCK_BACKEND, SERVER_URL } from "../constants";


export default async function getZip(taskId,userId,fileName) {
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Token a38e3aee826624041b52d53505c0d9c395053601");
    
    var formdata = new FormData();
    formdata.append("taskId", taskId);
    formdata.append("userId", userId);
    
    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: formdata,
      redirect: 'follow'
    };
    
    let response = await fetch(SERVER_URL +"/v1/getzip/", requestOptions)
    console.log("-----------------------------------")
    let name = await response.headers
    console.log(name)
    response = await response.blob()
    console.log(response)
      download(response,fileName+".zip")
    return true;
}